import React, { FC, useState } from "react";
import { Grid, Tab, Tabs, useMediaQuery } from "@material-ui/core";
import PoolDetailStyle from "./DetailsStyle";
import AboutSection from "./AboutSection";
import UpdateSection from "./UpdateSection";
import VestingSection from "./VestingSection";
import theme from "../../helpers/theme";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel (props: TabPanelProps) {
    
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index }
            id={`pool-info-tabpanel-${index}`}
            aria-labelledby={`pool-info-tab-${index}`}
            { ...other }
        >
            {
                value === index && (
                    <Grid item>
                        {
                            children
                        }
                    </Grid>
                )
            }
        </div>
    )
}

function a11yProps(index: number) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const PoolInfoTabSection: FC<any> = ({ poolContent, poolData }: any) => {

    const classes = PoolDetailStyle();
    const isActive = useMediaQuery(theme.breakpoints.down("sm"));

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabValue(newValue);
    }

    return (
        <Grid
            container
            lg={12}
            direction="column"
        >
            {
                poolData?.status === 'closed' && poolData?.investments && poolData.investments.length > 0 && (
                    <Grid
                        item
                        sm={12}
                        lg={12}
                        md={12}
                        xs={12}
                        style={{
                            marginTop: "10px",
                        }}
                    >
                        <Tabs
                            variant="scrollable"
                            scrollButtons={ isActive ? "on" : "off"}
                            aria-label="auto tabs pool info"
                            value={tabValue}
                            onChange={handleTabChange}
                        >
                            <Tab
                                label="Overview"
                                className={classes.tab}
                                {
                                    ...a11yProps(0)
                                }
                            />
                            {/* <Tab
                                label="Updates"
                                className={classes.tab}
                                {
                                    ...a11yProps(1)
                                }
                            /> */}
                            <Tab
                                label="Vesting"
                                className={classes.tab}
                                {
                                    ...a11yProps(1)
                                }
                            />
                        </Tabs>
                    </Grid>
                )
            }
            <Grid
                item
                sm={12}
                lg={12}
                md={12}
                xs={12}
            >
                <TabPanel value={tabValue} index={0}>
                    <AboutSection poolData={poolData} poolContent={poolContent} />
                </TabPanel>
                {/* <TabPanel value={tabValue} index={2}>
                    <UpdateSection />
                </TabPanel>  */}
                {
                    poolData?.investments && poolData?.investments.length > 0 && (
                        <TabPanel value={tabValue} index={1}>
                            <VestingSection pool={poolData} />
                        </TabPanel>
                    )
                }
            </Grid>
        </Grid>
    )
}

export default PoolInfoTabSection;